module.exports = __webpack_public_path__ + "5702d1cd2f428ea56b65317c7c09e66e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/suppliers/bid_title0.jpg
// module id = 548
// module chunks = 21 77